module.exports = __webpack_public_path__ + "img/បាល់ទាត់.9455bb94.png";